import { RouterProvider } from "react-router";
import { router } from "./router";
import { AuthProvider } from "../contexts/AuthContext";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { OfflineBanner } from "./components/OfflineBanner";

// There is deliberately no root CountyConfigProvider. Outside a county-scoped
// provider the context default is already the generic national config (the
// same resolveCountyConfig call a county-less root provider made for the
// "unknown_us" id, which has no county_configs row), and the provider module
// statically imports the whole CIE registry, so mounting it here kept every
// county's config on the critical path of every page, including the homepage.
// County scopes mount per route through LazyCountyConfigProvider (router.tsx,
// wrappers/index.tsx); scripts/ci/entry-chunk-weight-scan.mjs guards the entry.
function App() {
  return (
    <ErrorBoundary message="Something unexpected happened. Please refresh the page.">
      <OfflineBanner />
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
